<template>
    <modal-base :pacifier="false">
        <template #title>Live Connection Was Unsuccessful</template>

        <template #subtitle v-if="hasCalendly">Schedule an appointment with your Unbundled Lawyer below:</template>
    </modal-base>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        mounted() {
            this.$store.commit('card', 'calendar');
        },

        computed: {
            ...mapGetters([
                'hasCalendly',
            ]),
        }
    }
</script>
